<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <loadingcomp v-bind:mesaj="' '" v-model="loadingvmodel"></loadingcomp>
    <snackbarcomp v-bind:mesaj="text1" v-model="snackbar"></snackbarcomp>

    <v-card color="grey lighten-5" flat>
      <v-layout row wrap>
        <v-flex xs12 sm12>
          <v-toolbar size="120px" dark color="info">
            <v-toolbar-title> {{ $t('Accounting-Code') }} </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-text-field
              :label="$t('Search-Accounting-Code')"
              v-model="searchData.SearchText"
              flat=""
              solo-inverted=""
              hide-details
              append-icon="search"
            ></v-text-field>
            &nbsp;
            <v-tooltip bottom>
              <v-btn
                :disabled="!sayfayetki.Save"
                slot="activator"
                @click="gitAdd()"
                flat
              >
                <span class="hidden-sm-and-down"> {{ $t('Add') }} </span>
                <v-icon right dark>add_box</v-icon>
              </v-btn>
              <span v-if="!sayfayetki.Save">{{ $t('Limited-Authorization') }}</span>
              <span v-if="sayfayetki.Save">{{ $t('Add') }}</span>
            </v-tooltip>
      
          </v-toolbar>
        </v-flex>

        <v-flex xs12 sm12 md12 pa-3>
          <v-layout row wrap>
            <v-flex
              pa-1
              xs12
              sm6
              md4
              v-for="item in hesapgurubu"
              v-bind:key="item.CodeID"
            >
              <v-hover>
                <v-card
                  flat=""
                  slot-scope="{ hover }"
                  :class="`elevation-${hover ? 12 : 2}`"
                  class="mx-auto"
                  width="100%"
                >
                  <a @click="gitUpdate(item)">
                    <v-card flat="" class="grey--text">
                      <v-layout>
                        <v-flex xs3>
                          <img
                            height="95%"
                            width="95%"
                            style="padding-left: 10%; padding-top: 10%"
                            src="../../../../assets/images/business.png"
                          />
                        </v-flex>
                         <v-flex xs9>
                          <v-layout row wrap align-center>
                            <v-flex xs12 sm12 md6>
                              <v-list dense>
                                <v-list-tile>
                                  <v-list-tile-action>
                                    <v-icon color="#67768f">money</v-icon>
                                  </v-list-tile-action>
                                  <v-list-tile-content>
                                    <v-list-tile-title>
                                      <span
                                        class="font-weight-medium grey--text body-2"
                                      >
                                        {{ item.Currency }}
                                      </span>
                                    </v-list-tile-title>
                                  </v-list-tile-content>
                                </v-list-tile>
                                <v-list-tile>
                                  <v-list-tile-action>
                                    <v-icon color="#67768f"
                                      >account_balance</v-icon
                                    >
                                  </v-list-tile-action>
                                  <v-list-tile-content>
                                    <v-list-tile-title>
                                      <span
                                        class="font-weight-medium grey--text body-2"
                                      >
                                        {{ item.AccountGroup }}
                                      </span>
                                    </v-list-tile-title>
                                  </v-list-tile-content>
                                </v-list-tile>
                              </v-list>
                            </v-flex>
                            <v-flex xs12 sm12 md6>
                              <v-list tense>
                                <v-list-tile>
                                  <v-list-tile-action v-if="item.CodeLocked">
                                    <v-chip color="indigo" text-color="white">
                                      <v-avatar>
                                        <v-icon color="white">lock</v-icon>
                                      </v-avatar>
                                      {{ $t('Locked-Acccount') }}
                                    </v-chip>
                                  </v-list-tile-action>
                                </v-list-tile>
                                <v-list-tile>
                                  <v-list-tile-action
                                    v-if="item.CodeActivePassive"
                                  >
                                    <v-chip color="gray" text-color="white">
                                      <v-avatar>
                                        <v-icon color="white"
                                          >toggle_off</v-icon
                                        >
                                      </v-avatar>
                                      {{ $t('Passive-Account') }}
                                    </v-chip>
                                  </v-list-tile-action>
                                </v-list-tile>
                              </v-list>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                      <v-divider light></v-divider>
                      <v-flex xs12 sm12>
                        <v-list>
                          <v-list-tile>
                            <v-list-tile-action>
                              <v-icon color="#67768f">tag</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                <span
                                  class="font-weight-medium grey--text body-2"
                                >
                                  {{ item.CodeName }}
                                </span>
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>
                          <v-divider inset></v-divider>
                          <v-list-tile>
                            <v-list-tile-action>
                              <v-icon color="#67768f">share</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                <span
                                  class="font-weight-medium grey--text body-2"
                                >
                                  {{ item.Code }}
                                </span>
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>
                        </v-list>
                      </v-flex>
                    </v-card>
                  </a>
                </v-card>
              </v-hover>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
import loadingcomp from "@/components/app/customcomp/loadingcomp";
import helpers from "@/components/app/customcomp/helpers.js";
import auth from "@/api/auth";

export default {
  data() {
    return {
      text1: null,
      snackbar: false,
      yetkidialog: false,
      loadingvmodel: false,
      hesapgurubu: [],
      sayfayetki: {
        Screen: false,
        Update: false,
        Save: false,
        Delete: false,
        Status: false,
        Message: null,
        islem: 0,
      },
      searchData: {
        UserID: 0,
        CodeID: 0,
        CompanyID: 0,
        Code: null,
        SearchText: null,
      },
      credentials: JSON.parse(window.localStorage.getItem("credentials")),
    };
  },
  methods: {
    getDataWithSearch(searchText) {
      this.hesapgurubu = [];
      this.searchData.SearchText = searchText;
      this.searchData.UserID = this.credentials.UserID;
      this.searchData.CompanyID = this.credentials.MuhasebeSirketNo;
      this.$http
        .post(
          auth.API_URL + "api/AccountingCodes/AccountingCodeList",
          this.searchData,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
          }
        )
        .then(
          (response) => {
            this.hesapgurubu = response.body;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-AccountingCodeList";
              this.snackbar = true;
            } else {
              this.text1 = "Service Unavailable-AccountingCodeList";
              this.snackbar = true;
            }
          }
        );
    },
    getData() {
      this.loadingvmodel = true;
      this.searchData.SearchText = null;
      this.searchData.UserID = this.credentials.UserID;
      this.searchData.CompanyID = this.credentials.MuhasebeSirketNo;
      this.$http
        .post(
          auth.API_URL + "api/AccountingCodes/AccountingCodeList",
          this.searchData,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
          }
        )
        .then(
          (response) => {
            this.hesapgurubu = response.body;
            this.loadingvmodel = false;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-AccountingCodeList";
              this.snackbar = true;
              this.loadingvmodel = false;
            } else {
              this.text1 = "Service Unavailable-AccountingCodeList";
              this.snackbar = true;
              this.loadingvmodel = false;
            }
          }
        );
    },
    gitAdd() {
      var url = "#/muhasebe/muhasebekodlari/islem/id?islem=new";
      window.open(url, "_blank");
    },
    gitUpdate(val) {
      var url =
        "#/muhasebe/muhasebekodlari/islem/id?" +
        "islem=get&Code=" +
        val.Code +
        "&CompanyID=" +
        val.CompanyID +
        "&CodeID=" +
        val.CodeID;
      window.open(url, "_blank");
    },
  },
  watch: {
    "searchData.SearchText": function (searchText) {
      if (searchText.length > 2) {
        this.getDataWithSearch(searchText);
      }
    },
  },
  components: {
    yetkidialog,
    snackbarcomp,
    loadingcomp,
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from.path;
    });
  },
  mounted() {
    this.sayfayetki = helpers.pageScreenAuth(this.$route.name);

    if (this.sayfayetki.Status == true) {
      //this.getData(); AÇılışta arama kaldırıldı
    } else {
      this.$refs.yetkidialog
        .open(this.sayfayetki.Message, this.sayfayetki.islem)
        .then((sonuc) => {
          if (sonuc == true) {
            if (this.prevRoute != null) {
              let url = "#" + this.prevRoute;

              window.open(url, "_self");
            } else {
              let url = "#/";
              window.open(url, "_self");
            }
          } 
        });
    }
  },
};
</script>

<style>
</style>